<template>
  <div class="notification" :class="notificationClass" @click="trackNotificationTileClick(notification.notif_type)">
    <div class="icon-container">
      <i class="icon fa" :class="notificationIcon"></i>
    </div>
    <div class="main-body">
      <div class="text-container">
        <p class="lead">{{ notification.heading }}</p>
        <p class="primary" v-if="notification.content">{{ notification.content }}</p>
        <p class="sub" v-if="notification.created_at">{{ timestamp }}</p>
        <span v-if="!notification.read_at" ref="unread-circle" class="unread-circle"></span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import { CommonTracker } from 'mixins/analytics'

export default {
  props: {
    notification: {
      required: true,
      type: Object
    }
  },
  mixins: [CommonTracker],
  methods: {
    trackNotificationTileClick (name) {
      this.trackEvent(this.analytics.V2.NotificationTileClickEvent, [name])
    }
  },
  computed: {
    notificationClass () {
      return this.notificationData[this.notification.notif_type]
        ? this.notificationData[this.notification.notif_type].class
        : 'notification-default'
    },

    notificationIcon () {
      return this.notificationData[this.notification.notif_type]
        ? this.notificationData[this.notification.notif_type].icon
        : 'fa-plus'
    },

    timestamp () {
      return moment(this.notification.created_at).fromNow()
    },

    notificationData () {
      return {
        applied_talent_declined: {
          class: 'notification-info',
          icon: 'fa-thumbs-down'
        },
        request_created: {
          class: 'notification-success',
          icon: 'fa-paper-plane'
        },
        talent_applied: {
          class: 'notification-info',
          icon: 'fa-plus'
        },
        request_vetted: {
          class: 'notification-success',
          icon: 'fa-bolt'
        },
        account_activated: {
          class: 'notification-success',
          icon: 'fa-bolt'
        },
        request_to_be_reviewed: {
          class: 'notification-info',
          icon: 'fa-question'
        },
        booking_date_change: {
          class: 'notification-info',
          icon: 'fa-exclamation-triangle'
        },
        talent_final_reminder: {
          class: 'notification-info',
          icon: 'fa-suitcase'
        },
        talent_second_reminder: {
          class: 'notification-info',
          icon: 'fa-suitcase'
        },
        talent_initial_reminder: {
          class: 'notification-info',
          icon: 'fa-suitcase'
        },
        event_booked: {
          class: 'notification-success',
          icon: 'fa-check'
        },
        booking_completed: {
          class: 'notification-success',
          icon: 'fa-handshake-o'
        },
        bank_transfer_payment_received: {
          class: 'notification-info',
          icon: 'fa-check'
        },
        booking_created: {
          class: 'notification-success',
          icon: 'fa-user-circle'
        },
        booking_reactivated: {
          class: 'notification-success',
          icon: 'fa-user-circle'
        },
        talent_confirmed_attendance: {
          class: 'notification-info',
          icon: 'fa-space-shuttle'
        },
        talent_accepted: {
          class: 'notification-success',
          icon: 'fa-star'
        },
        talent_deposit_paid: {
          class: 'notification-success',
          icon: 'fa-lock'
        },
        client_confirmed: {
          class: 'notification-success',
          icon: 'fa-lock'
        },
        talent_payment_sent: {
          class: 'notification-success',
          icon: 'fa-money'
        },
        shortlisted_for_request: {
          class: 'notification-success',
          icon: 'fa-users'
        },
        booking_cancelled: {
          class: 'notification-error',
          icon: 'fa-frown-o'
        },
        request_cancelled: {
          class: 'notification-error',
          icon: 'fa-frown-o'
        },
        deposit_warning: {
          class: 'notification-error',
          icon: 'fa-exclamation-triangle'
        },
        final_warning: {
          class: 'notification-error',
          icon: 'fa-exclamation-triangle'
        },
        booking_accepted: {
          class: 'notification-success',
          icon: 'fa-star'
        },
        talent_importer_success: {
          class: 'talent-importer-success',
          icon: 'fa-check'
        },
        talent_importer_fail: {
          class: 'talent-importer-fail',
          icon: 'fa-times'
        },
        package: {
          class: 'notification-success',
          icon: 'fa-check'
        },
        package_negative: {
          class: 'notification-error',
          icon: 'fa-cross'
        },
        package_reminder: {
          class: 'notification-info',
          icon: 'fa-clock-o'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main-body {
  width: 100%;
}
.text-container {
  position: relative;
  padding-right: 20px;
  width: 100%;
}
.unread-circle {
  position: absolute;
  top: 15px;
  right: 15px;
}
</style>
